/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

export interface IAdressLabel {
    id: string;
    text: string;
}

/**
 * Address label.
 * @param props - Configuration of the functional component.
 * @returns React functional component.
 */
export const AddressLabelFunctionComponent: React.FC<IAdressLabel> = (props: IAdressLabel) => {
    const { id: itemId, text } = props;
    const isPhone = itemId === 'shipping_addressphone';
    const [showTooltip, setShowTooltip] = React.useState(false);
    return (
        <>
            {isPhone ? (
                <div className=' shipping-phone-label-container'>
                    <label className='msc-address-form__label shipping-phone-label ' htmlFor={itemId}>
                        {text}
                    </label>
                    <span
                        className={`dobbies-tooltip-icon ${showTooltip ? 'add-bg' : ''}`}
                        onClick={() => setShowTooltip(prev => !prev)}
                    ></span>
                    {showTooltip && <span className='dobbies-tooltip-icon-text'>For communication about your order.</span>}
                    {/* <div className='dobbies-tooltip'>In case the carrier needs to get in contact with you</div> */}
                </div>
            ) : (
                <label className='msc-address-form__label' htmlFor={itemId}>
                    {text}
                </label>
            )}
        </>
    );
};

export default AddressLabelFunctionComponent;
